import {useContext} from 'react'

import PropTypes from 'prop-types'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import PlaySolid from '@adv-mt/mt-svg-icons/lib/PlaySolid'
import IconVideocameraOutline from '@adv-mt/mt-svg-icons/lib/VideocameraOutline'

const BASE_CLASS = 'mt-HeroDealer'

const PlayButton = ({isDesktop = true, onClick = () => null}) => {
  const {i18n} = useContext(Context)

  return isDesktop ? (
    <div className={`${BASE_CLASS}-videoControl`}>
      <div className={`${BASE_CLASS}-videoControlPlay`}>
        <PlaySolid size={ATOM_ICON_SIZES.extraLarge} onClick={onClick} />
      </div>
    </div>
  ) : (
    <div
      className={`${BASE_CLASS}-videoButton`}
      onClick={e => {
        e.preventDefault()
        onClick()
      }}
    >
      <IconVideocameraOutline />
      {i18n.t('COMMON.VIDEO')}
    </div>
  )
}

PlayButton.propTypes = {
  isDesktop: PropTypes.bool,
  onClick: PropTypes.func
}

export default PlayButton
